import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { formatErr } from "@/lib/api";

const LOGO = "/assets/logo-nostradamus-oficial.png?v=3";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", instituicao: "" });
  const [err, setErr] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await register(form);
      setSubmitted(true);
      // ProtectedRoute / Layout will now show the pending screen because status = pending_approval
      setTimeout(() => nav("/dashboard"), 1200);
    } catch (ex) {
      setErr(formatErr(ex));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="bg-[#0F1B2D] text-white text-[11px] py-1.5 px-6 uppercase tracking-wider font-mono">
        Marinha do Brasil · Escola de Guerra Naval · LSC
      </div>

      <main className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden">
          <div className="flex flex-col items-center text-center px-6 pt-8 pb-2">
            <img src={LOGO} alt="LSC/EGN" className="w-[100px] h-auto mb-4" />
            <h1 className="font-display font-bold text-2xl text-[#0F1B2D]">Solicitar Acesso</h1>
            <p className="text-xs text-slate-500 mt-1">Projeto Nostradamus · LSC/EGN</p>
          </div>

          <div className="p-6">
            {submitted ? (
              <div className="text-center space-y-3 py-6" data-testid="register-pending">
                <div className="w-12 h-12 mx-auto rounded-full bg-[#C5A028]/10 border border-[#C5A028] flex items-center justify-center text-[#C5A028] text-xl">✓</div>
                <h2 className="font-display font-bold text-lg text-[#0F1B2D]">Solicitação registrada</h2>
                <p className="text-sm text-slate-600 leading-relaxed">
                  Seu cadastro foi recebido e está aguardando aprovação de um administrador
                  do Projeto Nostradamus.
                </p>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-3" data-testid="register-form">
                {[
                  { k: "name", label: "Nome completo", type: "text" },
                  { k: "email", label: "E-mail institucional", type: "email" },
                  { k: "password", label: "Senha", type: "password" },
                  { k: "instituicao", label: "Instituição / OM", type: "text", optional: true },
                ].map((f) => (
                  <div key={f.k}>
                    <label className="text-[11px] tracking-widest font-semibold uppercase text-slate-500 block mb-1.5">
                      {f.label}
                    </label>
                    <input
                      type={f.type}
                      className="w-full bg-white border border-slate-300 rounded-md px-3 py-2 text-sm text-[#0F1B2D] focus:outline-none focus:ring-2 focus:ring-[#1E3A5F] focus:border-[#1E3A5F]"
                      value={form[f.k]}
                      onChange={(e) => setForm({ ...form, [f.k]: e.target.value })}
                      required={!f.optional}
                      data-testid={`register-${f.k}-input`}
                    />
                  </div>
                ))}

                {err && (
                  <div className="text-sm text-red-700 border border-red-200 bg-red-50 p-3 rounded" data-testid="register-error">
                    {err}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#0F1B2D] hover:bg-[#1E3A5F] disabled:opacity-60 text-white font-semibold rounded-md py-2.5 text-sm tracking-wide"
                  data-testid="register-submit-button"
                >
                  {loading ? "ENVIANDO…" : "ENVIAR SOLICITAÇÃO"}
                </button>

                <div className="mt-3 text-[11px] leading-relaxed text-slate-500 border-l-2 border-[#C5A028] bg-slate-50 p-3 rounded-r">
                  O acesso ao sistema é liberado somente após aprovação manual de um
                  administrador do Projeto Nostradamus.
                </div>

                <div className="text-center pt-2">
                  <Link to="/login" className="text-xs text-[#1E3A5F] hover:underline font-semibold">
                    Já tenho conta · Entrar
                  </Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
